export enum MinigameState {
    INTRO,
    PLAYING,
    LOST,
    WON,
    SAD_AGAIN,
}
